import React from "react";
import { Text, Button, Box, Tag } from "@chakra-ui/react";
import { IoAdd } from "react-icons/io5";
import { Link } from "react-router-dom";
import { PageHeader, Wrapper, Table } from "components";
import { OrganizationStatusEnum } from "requests";
import { Filters, InvitationResending, StatusChange } from "./components";
import { useOrganizations, Organization } from "./duck";

const List: React.FC = () => {
  const { organizations, totalCount, loading, refetch } = useOrganizations();

  return (
    <>
      <PageHeader
        title="Organizations"
        actions={
          <Link to="./create">
            <Button leftIcon={<IoAdd />}>New Organization</Button>
          </Link>
        }
      />

      <Wrapper mt={6}>
        <Filters />

        <Box mt="24px">
          <Table
            data={organizations}
            loading={loading}
            totalCount={totalCount}
            perPage={15}
            noDataMessage="No results found"
          >
            <Table.Column dataKey="name" label="Name" />
            <Table.Column
              dataKey="description"
              label="Description"
              render={({ value }) => (
                <Text whiteSpace="normal">{value || "-"}</Text>
              )}
            />
            <Table.Column<OrganizationStatusEnum>
              dataKey="status"
              label="Status"
              render={({ value }) =>
                value === OrganizationStatusEnum.Active ? (
                  <Tag colorScheme="green">Active</Tag>
                ) : (
                  <Tag colorScheme="red">Archived</Tag>
                )
              }
            />
            <Table.Column
              dataKey="contactEmail"
              label="Contact Email"
              render={({ value }) => <Text>{value || "-"}</Text>}
            />
            <Table.Column<number, Organization>
              w="108px"
              dataKey="_id"
              label="Action"
              render={({ value, record }) => (
                <Table.Actions
                  editURL={`/organization-management/${value}/edit/general`}
                  extra={
                    <>
                      <StatusChange
                        id={value}
                        status={record.status}
                        onSuccess={refetch}
                      />
                      {!record.adminRegistrationCompleted && (
                        <InvitationResending id={value} />
                      )}
                    </>
                  }
                />
              )}
            />
          </Table>
        </Box>
      </Wrapper>
    </>
  );
};

export default List;
